(function () {
  const STYLE_ID = 'brs-gifting-widget-style'

  const SHADOW_CSS = `
    :host {
      display: block;
      width: 100%;
      font-family: proxima-nova, var(--typeBasePrimary), sans-serif;
      color: #424839;
    }

    * {
      box-sizing: border-box;
    }

    h1, h2, h3, h4, legend,
    [class*="title"],
    [class*="heading"] {
      font-family: Sentient-Light, var(--typeHeaderPrimary), serif;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.4;
      color: #424839;
      margin: 0 0 14px;
    }

    form {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 100%;
    }

    .brs-gift-name-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      width: 100%;
    }

    @media (max-width: 749px) {
      .brs-gift-name-row {
        grid-template-columns: 1fr;
      }
    }

    label,
    [class*="label"] {
      display: block;
      position: static !important;
      transform: none !important;
      opacity: 1 !important;
      font-family: Sentient-Light, var(--typeHeaderPrimary), serif;
      font-size: 13px;
      line-height: 1.35;
      color: #7a7a72;
      margin: 0 0 6px;
      pointer-events: auto;
    }

    /* Reference mock: placeholder inside bordered box, not floating label + underline */
    label:has(+ input[placeholder]),
    label:has(+ textarea[placeholder]),
    input + label,
    input + [class*="label"],
    hr + label {
      display: none !important;
    }

    textarea + label,
    textarea + [class*="label"] {
      display: block !important;
      margin-top: 6px;
      font-size: 13px;
      color: #7a7a72;
    }

    input:not([type="hidden"]),
    textarea,
    select {
      width: 100%;
      min-height: 44px;
      padding: 12px 14px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      background: #ffffff;
      color: #424839;
      font-family: Sentient-Light, var(--typeHeaderPrimary), serif;
      font-size: 14px;
      line-height: 1.4;
      box-shadow: 0 1px 0 rgba(66, 72, 57, 0.04);
      appearance: none;
      -webkit-appearance: none;
    }

    textarea {
      min-height: 120px;
      resize: vertical;
      padding-bottom: 28px;
    }

    input::placeholder,
    textarea::placeholder {
      color: #b0b0a8;
      opacity: 1;
      font-family: Sentient-Light, var(--typeHeaderPrimary), serif;
    }

    input:focus,
    textarea:focus,
    select:focus {
      outline: none;
      border-color: #424839;
      box-shadow: 0 0 0 1px #424839;
    }

    /* Hide duplicate underline-style labels from default widget layout */
    hr,
    [class*="underline"],
    [class*="divider"] {
      display: none !important;
    }

    /* Gift amount / duration pills (inside widget when Recharge renders them) */
    fieldset:has(input[type="radio"]),
    [role="radiogroup"] {
      border: 0;
      padding: 0;
      margin: 0 0 12px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    fieldset:has(input[type="radio"]) input[type="radio"],
    [role="radiogroup"] input[type="radio"] {
      position: absolute;
      opacity: 0;
      pointer-events: none;
      width: 0;
      height: 0;
    }

    fieldset:has(input[type="radio"]) label,
    [role="radiogroup"] label,
    input[type="radio"] + label {
      display: block;
      width: 100%;
      margin: 0 !important;
      padding: 14px 20px !important;
      border-radius: 999px !important;
      border: 1px solid #e0e0e0 !important;
      background: #ffffff !important;
      box-shadow: none !important;
      text-align: left;
      font-size: 15px;
      color: #424839;
      cursor: pointer;
    }

    fieldset:has(input[type="radio"]) input[type="radio"]:checked + label,
    [role="radiogroup"] input[type="radio"]:checked + label,
    input[type="radio"]:checked + label {
      background: var(--colorBtnPrimary, #d0e5a4) !important;
      border-color: var(--colorBtnPrimary, #d0e5a4) !important;
      color: var(--colorTextBody, #424839) !important;
    }

    [class*="counter"],
    [class*="char"] {
      font-size: 12px;
      color: #7a7a72;
      text-align: right;
      margin-top: 4px;
    }

    button,
    [type="submit"] {
      width: 100%;
      margin-top: 8px;
      line-height: 1.42;
      text-align: center;
      padding: var(--btnPadding, 11px 25px);
      border-radius: var(--buttonRadius, 50px);
      border: 1px solid transparent;
      background: var(--colorBtnPrimary, #d0e5a4);
      color: var(--colorTextBody, #424839);
      font-family: var(--typeHeaderPrimary), Sentient-Light, serif;
      font-size: calc(var(--typeBaseSize, 16px) + 2px);
      font-weight: var(--typeHeaderWeight, 400);
      box-shadow: none;
      cursor: pointer;
    }

    button:not([disabled]):hover,
    [type="submit"]:not([disabled]):hover {
      color: var(--colorBtnPrimaryText, #424839);
      background: var(--colorBtnPrimary, #d0e5a4);
    }

    button[disabled],
    [type="submit"][disabled] {
      cursor: default;
      color: var(--disabledGreyText, #b6b6b6);
      background-color: var(--disabledGrey, #f6f6f6);
      opacity: 1;
    }
  `

  const LIGHT_DOM_CSS = `
    .brs-gift-widget-light label:has(+ input[placeholder]),
    .brs-gift-widget-light label:has(+ textarea[placeholder]),
    .brs-gift-widget-light input + label,
    .brs-gift-widget-light hr {
      display: none !important;
    }
    .brs-gift-widget-light input:not([type="hidden"]),
    .brs-gift-widget-light textarea,
    .brs-gift-widget-light select {
      width: 100%;
      padding: 12px 14px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      background: #fff;
      font-family: Sentient-Light, serif;
      font-size: 14px;
      margin-bottom: 12px;
    }
    .brs-gift-widget-light .brs-gift-name-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
  `

  function isGiftTemplatePage() {
    return (
      document.body.classList.contains('template-subscription-gift-2') ||
      document.body.classList.contains('template-subscription-gifting')
    )
  }

  if (!isGiftTemplatePage()) return

  let applyQueued = false
  let domObserver = null

  function injectShadowStyles(host) {
    const root = host.shadowRoot
    if (!root || root.getElementById(STYLE_ID)) return

    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = SHADOW_CSS
    root.appendChild(style)
    layoutNameRowInRoot(root)
  }

  function layoutNameRowInRoot(root) {
    if (!root || root.dataset.brsNameRowDone === 'true') return

    const first = root.querySelector(
      'input[placeholder*="First" i], input[name*="first" i], input[id*="first" i]'
    )
    const last = root.querySelector(
      'input[placeholder*="Last" i], input[name*="last" i], input[id*="last" i]'
    )
    if (!first || !last || first === last) return

    const firstWrap = first.closest('div, fieldset, p, label') || first.parentElement
    const lastWrap = last.closest('div, fieldset, p, label') || last.parentElement
    if (!firstWrap || !lastWrap || firstWrap.contains(last) || lastWrap.contains(first))
      return

    const row = document.createElement('div')
    row.className = 'brs-gift-name-row'
    row.style.cssText =
      'display:grid;grid-template-columns:1fr 1fr;gap:12px;width:100%;'

    const parent = firstWrap.parentElement
    if (!parent || parent !== lastWrap.parentElement) return

    parent.insertBefore(row, firstWrap)
    row.appendChild(firstWrap)
    row.appendChild(lastWrap)
    root.dataset.brsNameRowDone = 'true'
  }

  function wrapLightDomFields(block) {
    if (!block || block.dataset.brsGiftLightReady === 'true') return

    const inputs = block.querySelectorAll(
      'input:not([type="hidden"]), textarea, select'
    )
    if (inputs.length === 0) return

    block.classList.add('brs-gift-widget-light')
    if (!block.querySelector('#brs-gift-light-style')) {
      const style = document.createElement('style')
      style.id = 'brs-gift-light-style'
      style.textContent = LIGHT_DOM_CSS
      block.appendChild(style)
    }

    block.dataset.brsGiftLightReady = 'true'
  }

  function findGiftingHosts() {
    return document.querySelectorAll('recharge-gifting-widget, .recharge-gifting-widget')
  }

  function findGiftingBlocks() {
    return document.querySelectorAll(
      '.shopify-app-block:has(recharge-gifting-widget), .shopify-app-block:has(.recharge-gifting-widget)'
    )
  }

  function allHostsStyled() {
    const hosts = findGiftingHosts()
    if (hosts.length === 0) return false
    return [...hosts].every((host) => {
      const root = host.shadowRoot
      return root && root.getElementById(STYLE_ID)
    })
  }

  function apply() {
    if (!isGiftTemplatePage()) return

    findGiftingHosts().forEach((host) => {
      injectShadowStyles(host)
      if (host.shadowRoot) layoutNameRowInRoot(host.shadowRoot)
      wrapLightDomFields(host)
    })

    findGiftingBlocks().forEach(wrapLightDomFields)

    if (allHostsStyled() && domObserver) {
      domObserver.disconnect()
      domObserver = null
    }
  }

  function scheduleApply() {
    if (applyQueued) return
    applyQueued = true
    window.requestAnimationFrame(() => {
      applyQueued = false
      apply()
    })
  }

  function boot() {
    apply()
    window.setTimeout(apply, 400)
    window.setTimeout(apply, 1500)
    window.setTimeout(apply, 3000)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  document.addEventListener('shopify:section:load', boot)

  if (typeof MutationObserver !== 'undefined') {
    domObserver = new MutationObserver(scheduleApply)
    domObserver.observe(document.documentElement, { childList: true, subtree: true })
  }
})()
